import { DayOffTemplate } from '@gooduncles/gu-app-schema';

import { AlimtalkTemplateConfig } from '../../types';

import DayOffAlimtalkPreview from './DayOffAlimtalkPreview';
import DayOffTemplateForm from './DayOffTemplateForm';

const isComplete = (params: Partial<DayOffTemplate>): params is DayOffTemplate => {
  return !!(
    params.date &&
    params.products &&
    params.until &&
    params.category01 &&
    params.inform &&
    params.mobile &&
    params.pc
  );
};

export const dayOffConfig: AlimtalkTemplateConfig<DayOffTemplate> = {
  label: '가락시장 휴장 안내',
  title: '카카오 알림톡 발송 (가락시장 휴장 안내)',
  templateCode: 'day-off',
  isComplete,
  FormComponent: DayOffTemplateForm,
  PreviewComponent: DayOffAlimtalkPreview,
};
